var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArdealyMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 657.31 549.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Actual_logo",
    "data-name": "Actual logo"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "519.26 137.53 244.88 137.53 244.59 137.24 244.59 137.53 137.29 137.53 137.29 274.89 137.12 275.07 137.29 275.07 137.29 549.12 .55 412.38 0 0 137.29 0 137.29 .29 137.46 .12 137.58 0 381.93 0 519.26 137.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "657.31 .65 657.31 137.53 519.59 137.53 519.49 0 657.31 .65"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "657.31 548.78 656.78 274.72 519.59 137.53 519.49 412.02 382.25 412.38 382.25 275.07 244.71 275.07 244.71 411.83 244.9 412.02 245.26 412.38 382.2 549.31 382.25 549.26 382.25 549.36 657.31 548.78"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArdealyMark);
export default __webpack_public_path__ + "static/media/ardealy-mark.c66cb6612fa69be825a3fa49b87d1afa.svg";
export { ForwardRef as ReactComponent };